var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 9.14837V8.25004C20.1667 3.66671 18.3334 1.83337 13.7501 1.83337H8.25008C3.66675 1.83337 1.83342 3.66671 1.83342 8.25004V13.75C1.83342 18.3334 3.66675 20.1667 8.25008 20.1667H9.16675",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0373 7.78573L4.53606 7.77925L7.13527 5.18004",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53662 7.77881L7.13583 10.378",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 14.8041V17.2791C11.9167 19.3416 12.7417 20.1666 14.8042 20.1666H17.2792C19.3417 20.1666 20.1667 19.3416 20.1667 17.2791V14.8041C20.1667 12.7416 19.3417 11.9166 17.2792 11.9166H14.8042C12.7417 11.9166 11.9167 12.7416 11.9167 14.8041Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeLeftIcon);
export default __webpack_public_path__ + "static/media/merge-left-icon.a6666de5deea887faae54d87e3da03e7.svg";
export { ForwardRef as ReactComponent };